<template>
  <div class="user-info-component">
    <div class="img-swiper" v-if="info.coverPicUrlList">
      <Swipe :autoplay="0" indicator-color="white" class="img-box" ref="swipe">
        <SwipeItem class="img-box" v-for="(img, index) in info.coverPicUrlList" :key="img" @click="showPreview(index)">
          <img class="img" :src="`${img}`" />
        </SwipeItem>
      </Swipe>
      <span class="img-num">{{info.coverPicList.length}}</span>
    </div>
    <div class="info-box" v-if="info.id">
      <div class="name-op-con">
        <span class="name-con"><i class="sex-icon" :class="{female: info.sex == 2}"></i><span
            class="nick">{{info.nickName}}</span><img class="identify-icon" src="~@/assets/img/identify.png"
            v-if="info.identityAuth === 3 && info.academicAuth === 3 && info.workAuth === 3" /></span>
        <span class="op-con" v-if="mId != info.mid">
          <a href="javascript:;" class="report btn" @click="switchReport">举报</a>
          <a href="javascript:;" class="follow btn" :class="{'followed': info.follow}"
            @click="switchFollow">{{info.follow ? '取消关注' : '关注'}}</a>
        </span>
      </div>
      <div class="id-con" ref="code-con"><strong class="id">ID: {{info.mid}}</strong><a href="javascript:;" v-if="$route.name === 'PersonInfo'"
          class="copy-btn" @click="execCopy(info.mid)">复制</a></div>
      
      <p class="info-con">
        <span class="info-img-con"><img src="~@/assets/img/info-age.png" alt="" class="info-img" /></span>
        {{info.age}}岁/{{calculater(info.birthday.split('-')[0])}}<span class="split"></span>{{info.high}}cm<span class="split"></span>{{constellationMap[info.constellation]}}
      </p>

      <p class="info-con">
        <span class="info-img-con"><img src="~@/assets/img/info-education.png" alt="" class="info-img" /></span>
        {{educationMap[info.education]}}{{info.ifStudent ? '在读' : ''}}
        <template v-if="info.school && info.schollVisible"><span class="split"></span>{{info.school}}</template>
      </p>
      <template v-if="!info.ifStudent">
        <p class="info-con desc">
          <span class="info-img-con"><img src="~@/assets/img/info-job.png" alt="" class="info-img" /></span>
          {{info.job}}<template v-if="!info.companyVisible"><span class="split"></span>{{info.industry}}</template><span class="split"></span>{{info.companyVisible && info.company ? `${info.company}` : '公司保密'}}
        </p>
      </template>

      <p class="info-con">
        <span class="info-img-con"><img src="~@/assets/img/info-salary.png" alt="" class="info-img" /></span>
        {{assetsMap[info.richesInfo]}}<span class="split"></span>
        {{info.annualSalaryVisible && info.annualSalary != 0 ? `年薪${salaryMap[info.annualSalary]}` : '年薪保密'}}</p>

      <p class="info-con"><span class="info-img-con"><img src="~@/assets/img/info-status.png" alt="" class="info-img" /></span>{{statusMap[info.singleStatus]}}</p>

      <p class="info-con location">
        <span class="info-img-con"><img src="~@/assets/img/info-location.png" alt="" class="info-img" /></span>
        {{cityText(info)}} <span class="split"></span> {{nativeCityText(info)}}
      </p>
    </div>

    <div class="desc-list" v-if="info.mid">
      <div class="desc-item">
        <span class="desc-top">自我描述</span>
        <pre class="desc-detail">{{info.selfDescription | wordWrap}}</pre>
      </div>
      <div class="desc-item">
        <span class="desc-top">兴趣爱好</span>
        <pre class="desc-detail">{{info.hobby | wordWrap}}</pre>
      </div>
      <div class="desc-item">
        <span class="desc-top">家庭背景</span>
        <pre class="desc-detail">{{info.familyInfo | wordWrap}}</pre>
      </div>
      <div class="desc-item">
        <span class="desc-top">个人经历</span>
        <pre class="desc-detail">{{info.personalExperience | wordWrap}}</pre>
      </div>
      <div class="desc-item">
        <span class="desc-top">理想的另一半</span>
        <pre class="desc-detail">{{info.ideaPartner | wordWrap}}</pre>
      </div>
      <div class="desc-item">
        <span class="desc-top">爱情观</span>
        <pre class="desc-detail">{{info.loveMind | wordWrap}}</pre>
      </div>
    </div>

    <van-image-preview v-if="info.coverPicUrlList" v-model="isShowPreview" :images="info.coverPicUrlList" :start-position="previewIndex" @change="changePreview"></van-image-preview>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { Swipe, SwipeItem } from 'vant'
import { copy } from '@/utils/tools'

export default {
  name: 'userInfo',
  components: {
    Swipe,
    SwipeItem
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      educationMap: 'educationMap',
      salaryMap: 'salaryMap',
      assetsMap: 'assetsMap',
      statusMap: 'statusMap',
      constellationMap: 'constellationMap',
      areaData: 'areaData'
    }),
    ...mapGetters({
      userId: 'userId',
      mId: 'mId'
    }),
    // 所在城市
    cityText (item) {
      return (item) => {
        if (!item.cityId) {
          return ''
        }
        if (parseInt(item.cityId) === 900000) return '现居' + (item.country + ' ' + item.state)
        return `现居${this.areaData['city_list'][item.cityId]}`
      }
    },
    nativeCityText (item) {
      return (item) => {
        if (!item.nativeCityId) {
          return ''
        }
        let nid = parseInt(item.nativeCityId)
        if (nid === 900000) {
          return item.nativeCountry + ' ' + item.nativeState + '人'
        } else {
          const provice = String(nid).substr(0,2) + '0000'
          return `${[110100, 120100, 310100, 500100].indexOf(nid) >= 0 ? '' : `${this.areaData['province_list'][provice]}`}${this.areaData['city_list'][item.nativeCityId]}人`
        }
      }
    }
  },
  data () {
    return {
      // 图片预览展示标识
      isShowPreview: false,
      previewIndex: 0
    }
  },
  filters: {
    wordWrap (val) {
      if (!val) return ''
      return val.replace(/↵/g,'\n')
    }
  },
  methods: {
    // 计算出生肖
    calculater (year) {
      var arr1 = ['猴', '鸡', '狗', '猪', '鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊']
      return /^\d{4}$/.test(year) ? `属${arr1[year % 12]}` : false
    },
    execCopy (text) {
      copy(text, this.$refs['code-con']).then(res => {
        this.$toast('复制成功')
      }, () => {
        this.$toast('复制失败')
      })
    },
    showPreview (index) {
      this.previewIndex = index
      this.isShowPreview = true
    },
    changePreview (index) {
      this.$refs['swipe'].swipeTo(index)
    },
    switchReport () {
      this.$emit('switchReport')
    },
    switchFollow () {
      this.$emit('switchFollow')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.user-info-component {
  .img-swiper {
    position: relative;
    height: 470px;
    border-radius: 8px;
    overflow: hidden;
  }
  .img-box {
    height: 100%;
    .van-swipe__indicators {
      left: auto;
      right: 40px;
    }
    .van-swipe__indicator {
      width: 8px;
      height: 8px;
      border-radius: 8px;
      opacity: 1;
      background-color: #fff;
    }
    .van-swipe__indicator--active {
      width: 30px;
      background-color: $mainColor !important;
    }
  }

  .info-box {
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  .name-op-con {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .name-con {
    flex: 1 1 auto;
    font-size: 32px;
    line-height: 44px;
    font-weight: bold;
    .nick {
      overflow: hidden;
      font-size: 38px;
      line-height: 44px;
      text-align: center;
      display: inline-block;
      max-width: 250px;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: text-bottom;
    }
    .sex-icon {
      display: inline-block;
      vertical-align: middle;
      margin-top: -4px;
      margin-right: 10px;
      width: 25px;
      height: 30px;
      background: url(_~@/assets/img/sex-flag.png) no-repeat 0 0;
      background-size: 50px 30px;
      &.female {
        background-position: 100% 0;
      }
    }
    .identify-icon {
      margin-left: 10px;
      width: 90px;
      vertical-align: middle;
    }
  }
  .op-con {
    .btn {
      display: inline-block;
      margin-left: 30px;
      padding: 0 30px;
      font-size: 19px;
      line-height: 38px;
      border-radius: 42px;
    }
    .report {
      color: #c5c5c5;
      border: 1px solid #c5c5c5;
    }
    .follow {
      color: $mainColor;
      border: 1px solid $mainColor;
    }
    .followed {
      color: #fff;
      background: $mainColor;
    }
  }
  .id-con {
    margin-top: 15px;
    padding-bottom: 16px;
    font-size: 28px;
    line-height: 40px;
    border-bottom: 1px solid #E0E0E0;
  }
  .id {
    display: inline-block;
    vertical-align: middle;
  }
  .copy-btn {
    display: inline-block;
    vertical-align: middle;
    margin-left: 30px;
    color: $mainColor;
    font-size: 20px;
    line-height: 28px;
  }
  .info-con {
    display: flex;
    align-items: center;
    margin-top: 16px;
    font-size: 24px;
    line-height: 34px;
    .split {
      margin: 0 15px;
      width: 2px;
      height: 24px;
      background: #B9B9B9;
    }
  }
  .info-img-con {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 32px;
    height: 30px;
  }
  .info-img {
    position: relative;
    max-width: 100%;
    max-height: 100%;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .desc-item {
    margin-top: 20px;
    .desc-top {
      position: relative;
      padding: 0 12px;
      font-size: 28px;
      line-height: 40px;
      font-weight: bold;
      &:before {
        content: '';
        position: absolute;
        bottom: 4px;
        left: 0;
        width: 100%;
        height: 16px;
        z-index: -1;
        background: rgba(255, 71, 149, 0.4);
      }
    }
    .self-description {
      position: absolute;
      top: 6px;
      left: 6px;
      width: 26px;
    }
    .desc-detail {
      margin-top: 10px;
      padding-left: 12px;
      color: #3E3E3E;
      font-size: 28px;
      white-space: pre-wrap;
      line-height: 44px;
      font-family: inherit;
    }
  }
}
</style>